import { render, staticRenderFns } from "./contact.vue?vue&type=template&id=a925f78a&scoped=true"
import script from "./contact.vue?vue&type=script&lang=js"
export * from "./contact.vue?vue&type=script&lang=js"
import style0 from "./contact.vue?vue&type=style&index=0&id=a925f78a&prod&scoped=true&lang=scss"
import style1 from "./contact.vue?vue&type=style&index=1&id=a925f78a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a925f78a",
  null
  
)

export default component.exports